// extracted by mini-css-extract-plugin
export default {"Tab":"Tab_Tab__+oiyq","Inactive":"Tab_Inactive__3ENzC","Active":"Tab_Active__yEIc-"};